import posthog from 'posthog-js'

export function captureException(error: unknown, context?: Record<string, unknown>) {
  const err = error instanceof Error ? error : new Error(String(error))
  posthog.captureException(err, context)
}
